// extracted by mini-css-extract-plugin
export var audioPlayer = "_sp-0";